module.exports = __webpack_public_path__ + "img/Philippines-2.8077255d.jpg";